module.exports = __webpack_public_path__ + "img/home-customize.25678799.jpg";